import {toCamelCase} from 'case-converter'

const statuses = {
  100: 'success',
  200: 'success',
  300: 'alert',
  400: 'warn',
  500: 'error',
  600: 'succes'
}

export const state = () => ({
  status: 'success',
  messages: {
    good: {
      en: 'All services are available',
      ru: 'Все сервисы доступны'
    },
    bad: {
      en: 'Malfunctions in ',
      ru: 'Неполадки в работе'
    }
  }
})

export const mutations = {
  setStatus(state, status) {
    state.status = statuses[status]
  },
  setService(state, {service, message}) {
    state.messages.bad.en = state.messages.bad.en + service
    state.messages.bad.ru = message
  }
}

export const actions = {
  async fetchStatus(state) {
    this.$http.$get('https://selectel.status.io/1.0/status/5980813dd537a2a7050004bd')
      .then(res => toCamelCase(res))
      .then(res => {
        const status = res?.result?.statusOverall?.statusCode
        state.commit('setStatus', status)

        if (status !== 100 && status !== 200) {
          const service = res.result?.status?.find(item => item?.statusCode === status)?.name
          const message = res.result?.incidents?.find(item => item?.messages?.find(item => item?.status === status))?.name
          state.commit('setService', {message, service})
        }
    })
  }
}

export const getters = {
  statusPanelMessage(state) {
    return (state.status === 'success')
      ? state.messages.good
      : state.messages.bad
  },
  statusPanel(state) {
    return state.status
  }
}